<div class="padding flex column">
	<b class="bold margin-bottom-small">Choose colors</b>

	@if (colors.length) {
		<div class="flex center margin-bottom-small">
			<i
				class="primary-dark hover margin-right-small fa {{
					allColorsSelected() ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
				}}"
				(click)="toggleSelectAll()"
			></i>
			<span>Select all</span>
		</div>
	}

	<div class="flex column gap scrollable">
		@for (color of colors; track color.id) {
			<div class="flex center border padding-small hover" (click)="toggleColor(color)">
				<i
					class="primary-dark margin-right-small fa {{
						color.selected ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
					}}"
				></i>
				<span>{{ color.code }} {{ color.name }}</span>
			</div>
		} @empty {
			<div class="flex center bg-light-grey padding">No colors available</div>
		}
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="apply()" [disabled]="disableApply()">
				<i class="fa-solid fa-check"></i>
				Apply
			</button>
		</div>
	</div>
</div>
